import { FC, useEffect } from 'react';
import { AxiosError } from 'axios';
import { useDispatch } from 'react-redux';
import { doRemoveAuth } from '../store/auth.slice';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useNotification from '../hooks/useNotification';

interface IProps {
  error?: AxiosError;
  badRequestMessage?: string;
  notFoundMessage?: string;
  ignoreNotFound?: boolean;
}

const ErrorResponse: FC<IProps> = ({
  error,
  badRequestMessage,
  notFoundMessage,
  ignoreNotFound = false,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useTranslation();
  const { warningNotification, errorNotification } = useNotification();

  useEffect(() => {
    if (!error?.response?.status) return;
    switch (error.response.status) {
      case 400:
        warningNotification(
          badRequestMessage ??
            (error.response?.data.data || t('common.message.error')),
        );
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        warningNotification(t('common.message.forbidden'));
        history.push('/');
        break;
      case 404:
        if (!ignoreNotFound) {
          warningNotification(notFoundMessage ?? t('common.message.notFound'));
        }
        break;
      default:
        errorNotification(
          error.response?.data.data ||
            error.response?.data.error ||
            t('common.message.error'),
        );
    }
  }, [error]);

  return null;
};

export default ErrorResponse;
